/**
 * Auto-adds Larmify larmtjänst subscription when a product with tag
 * "require-subscription" is added to the cart.
 */
(function () {
  const config = window.LarmifySubscription;
  if (!config?.variantId) return;

  let addInFlight = false;

  function cartHasSubscription(cart) {
    return cart.items.some(
      (item) =>
        item.variant_id === config.variantId ||
        item.handle === config.subscriptionHandle
    );
  }

  async function fetchCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch cart');
    return response.json();
  }

  async function ensureSubscriptionInCart() {
    if (addInFlight) return false;

    addInFlight = true;
    try {
      const cart = await fetchCart();
      if (cartHasSubscription(cart)) return false;

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: config.variantId,
              quantity: 1,
              selling_plan: config.sellingPlanId
            }
          ]
        })
      });

      const data = await response.json();
      if (!response.ok) {
        const message =
          typeof data.description === 'string'
            ? data.description
            : data.message || 'Failed to add subscription';
        throw new Error(message);
      }

      return true;
    } catch (error) {
      console.error('[LarmifySubscription]', error);
      return false;
    } finally {
      addInFlight = false;
    }
  }

  function refreshCartDrawer() {
    document.dispatchEvent(
      new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true })
    );
  }

  document.addEventListener('on:cart:add', async () => {
    if (!config.productRequiresSubscription) return;

    const added = await ensureSubscriptionInCart();
    if (added) refreshCartDrawer();
  });
})();
